import { url } from "../api";
import http from "./../utils/http";


export function login(userName, password) {
  return http.post(`${url}/api/auth`, JSON.stringify({ userName, password }));
}
